var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.826,
    height: 73.723,
    viewBox: "0 0 48.826 73.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mina_produkter",
    "data-name": "Mina produkter",
    transform: "translate(-13319.743 -1968.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26668",
    "data-name": "Group 26668",
    transform: "translate(13320.697 1990.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37313",
    "data-name": "Path 37313",
    d: "M.392,2.647-.352-1.3A1.008,1.008,0,0,1,.639-2.5a1.009,1.009,0,0,1,1.006,1.09L1.323,2.573",
    transform: "translate(0.37 2.496)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26735",
    "data-name": "Group 26735",
    transform: "translate(13321.348 1969.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26658",
    "data-name": "Group 26658",
    transform: "translate(9.164 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M0,11.745v-18.3a4.515,4.515,0,0,1,4.513-4.515H32.595a4.513,4.513,0,0,1,4.513,4.515v62.8a4.513,4.513,0,0,1-4.513,4.513H4.513A4.514,4.514,0,0,1,0,56.236V42.681",
    transform: "translate(0 11.074)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26659",
    "data-name": "Group 26659",
    transform: "translate(19.103 66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M0,0H17.229",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660",
    transform: "translate(22.522 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37305",
    "data-name": "Path 37305",
    d: "M0,0H6.957",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661",
    transform: "translate(32.773 4.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37306",
    "data-name": "Path 37306",
    d: "M0,0H.14",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26662",
    "data-name": "Group 26662",
    transform: "translate(0 19.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37307",
    "data-name": "Path 37307",
    d: "M0,3.185,19.679-3,33.992,3.333,16.773,9.521Z",
    transform: "translate(0 3.003)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26663",
    "data-name": "Group 26663",
    transform: "translate(0 25.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37308",
    "data-name": "Path 37308",
    d: "M0,0V22.735a2.076,2.076,0,0,0,1.224,1.894l14.509,6.536a2.073,2.073,0,0,0,1.644.027l15.467-6.357A2.077,2.077,0,0,0,34.132,22.9L33.992.148",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26664",
    "data-name": "Group 26664",
    transform: "translate(16.771 32.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37309",
    "data-name": "Path 37309",
    d: "M0,12.861V-12.126",
    transform: "translate(0 12.126)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26665",
    "data-name": "Group 26665",
    transform: "translate(19.678 19.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37310",
    "data-name": "Path 37310",
    d: "M0,0V11.48",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26666",
    "data-name": "Group 26666",
    transform: "translate(32.112 20.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37311",
    "data-name": "Path 37311",
    d: "M.392,2.647-.352-1.3A1.008,1.008,0,0,1,.639-2.5a1.009,1.009,0,0,1,1.006,1.09L1.323,2.573",
    transform: "translate(0.37 2.496)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26667",
    "data-name": "Group 26667",
    transform: "translate(18.396 14.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37312",
    "data-name": "Path 37312",
    d: "M.392,2.647-.352-1.3A1.008,1.008,0,0,1,.639-2.5a1.009,1.009,0,0,1,1.006,1.09L1.323,2.573",
    transform: "translate(0.37 2.496)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26669",
    "data-name": "Group 26669",
    transform: "translate(15.19 26.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37314",
    "data-name": "Path 37314",
    d: "M.392,2.647-.352-1.3A1.008,1.008,0,0,1,.639-2.5a1.009,1.009,0,0,1,1.006,1.09L1.323,2.573",
    transform: "translate(0.37 2.496)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26670",
    "data-name": "Group 26670",
    transform: "translate(28.848 40.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37315",
    "data-name": "Path 37315",
    d: "M2.7,0-2.55,1.752",
    transform: "translate(2.55)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26671",
    "data-name": "Group 26671",
    transform: "translate(27.098 43.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37316",
    "data-name": "Path 37316",
    d: "M3.587,0-3.382,2.423",
    transform: "translate(3.382)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26672",
    "data-name": "Group 26672",
    transform: "translate(25.01 46.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37317",
    "data-name": "Path 37317",
    d: "M4.661,0-4.4,3.206",
    transform: "translate(4.395)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductLibrary);
export default __webpack_public_path__ + "static/media/Icon_productLibrary.8965d9f1503125115f17c7263ebd1e8b.svg";
export { ForwardRef as ReactComponent };